export default function FormSubmitted() {
    return (
      <div className="completed-text">
        <p className="success-text">Your application for EZBenefits has been submitted successfully. </p>
      </div>
    );
};